<template>
  <div>
    <div
      v-if="rule.name"
      class="mt-2"
    >
      <span class="rounded-full bg-theme-500 px-3 py-1 text-xs font-bold text-white inline-flex flex-grow-0 flex">{{ rule.name }} {{ getRequisitesCreditsRangeLabel(relatedRequisites, [rule]) }}</span>
    </div>
    <div
      v-if="rule.description && rule.description !== '<p></p>'"
      class="mt-2"
    >
      <RichContent  class="reset-liststyle" :content="rule.description" />
    </div>
    <span class="font-bold">{{ displayString }}</span>
    <template v-if="rules && rules.length">
      <div
        v-for="(subRule, index) in rules"
        :key="`subRule-${index}`"
      >
        <div v-if="index > 0" class="rule-divider">
          <span class="divider-text">{{ getDividerText() }}</span>
        </div>
        <RequisitesSimpleRule
          :rule="subRule"
          :related-requisites="relatedRequisites"
          class="ml-4 mt-2 mb-4"
          @showModal="$emit('showModal', $event)"
        />
      </div>
    </template>
    <RequisiteSimpleDataSelect
      v-else-if="shouldShowDataSelect"
      :related-requisites="relatedRequisites"
      :selection="rule.value || {}"
      class="ml-4 pl-4 ruleBorder"
      @showModal="$emit('showModal', $event)"
    />
    <div
      v-if="rule.notes && rule.notes !== '<p></p>'"
      class="ml-4 mt-2"
    >
      <RichContent  class="reset-liststyle" :content="rule.notes" />
    </div>
  </div>
</template>

<script>
import RequisitesSimpleRuleDefaults from '../../RequisitesSimpleRuleDefaults'
import RequisiteSimpleDataSelect from './RequisiteSimpleDataSelect'
import RichContent from '@/components/RichContent'

export default {
  components: { RequisiteSimpleDataSelect, RichContent },
  ...RequisitesSimpleRuleDefaults,
  methods: {
    getDividerText() {
      const condition = this.rule.condition
      if (condition === 'allOf') return 'AND'
      return 'OR'
    }
  }
}
</script>

<style scoped>
.ruleBorder {
  border-left: 1px solid black !important;
}

.rule-divider {
  position: relative;
  height: 20px;
  margin: 15px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rule-divider::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 1px;
  background-color: #d1d5db;
}

.divider-text {
  background-color: white;
  padding: 0 15px;
  font-weight: 600;
  font-size: 12px;
  color: #6b7280;
  z-index: 1;
  position: relative;
}
</style>
